export const barMenuData = {
  husetsVin: [
    {
      name: "Husets Vin",
      description: "Rött / Vitt",
      priceGlas: "95",
      priceFlaska: "349",
      origin: ""
    }
  ],
  vittVin: [
    {
      name: "Maubet Blanc Sec",
      description: "Frankrike/Sydväst. Friskhet och livfullhet, med vackra aromer av citrus och pomelo. Passar perfekt till stark mat, asiatisk, sallader, fisk, vitt kött, skaldjur.",
      price: "379",
      type: "Flaska"
    },
    {
      name: "Lenotti Pinot Grigio delle Venezie",
      description: "Italien/Veneto. Torrt, friskt och aromatiskt. Passar till: Hors d'oeuvres, skaldjur, vit fisk, kött och starka rätter.",
      price: "549",
      type: "Flaska"
    },
    {
      name: "Gewurztraminer Rosenberg",
      description: "Frankrike/Alsace. Tydlig doft av litchi, kryddig och pepprig smak med inslag av ingefära. Harmoniskt och balanserat vin.",
      price: "679",
      type: "Flaska"
    }
  ],
  rottVin: [
    {
      name: "Maubet Rouge",
      description: "Frankrike/Sydväst. Druva: Tannat, Merlot. Mogna röda frukter, rund och len med rostade toner. Passar till: Stark mat och grillat kött.",
      price: "379",
      type: "Flaska"
    },
    {
      name: "Bardolino Classico",
      description: "Italien/Veneto. Torrt, fräscht och lätt, perfekt för alla tillfällen. Passar till: kötträtter, fisk och mm.",
      price: "549",
      type: "Flaska"
    }
  ],
  roseVin: [
    {
      name: "Millesimato Extra Dry",
      description: "Italien/Veneto. Delikat och doftande palett, behagligt fruktig med markerad inslag av frukt som jordgubb, hallon, körsbär och blommiga toner som ros. Extremt spännande, elegant och balanserad.",
      price: "99",
      type: "20cl"
    }
  ],
  prosecco: [
    {
      name: "Borgo Molino",
      description: "Italien/Veneto. Halmgul med fina pärlande bubblor, fruktigt och blommigt, något söt. Utmärkt som aperitif och sällskapsvin.",
      price: "99",
      type: "20cl"
    }
  ],
  cocktails: [
    {
      name: "Whiskey Sour",
      description: "Whiskey, egg white & lime.",
      price: "179"
    },
    {
      name: "Blueberry Cocktail",
      description: "Rom, blåbär & lime.",
      price: "179"
    },
    {
      name: "Piña Colada",
      description: "Rom, kokosgrädde & ananasjuice.",
      price: "179"
    },
    {
      name: "Strawberry Daiquiri",
      description: "Rom, lime & jordgubbar.",
      price: "179"
    },
    {
      name: "Mojito",
      description: "Rom, mynta, lime, socker & bubbelvatten.",
      price: "179"
    },
    {
      name: "White Russian",
      description: "Vodka, Kahlua & grädde.",
      price: "179"
    },
    {
      name: "Orgasm Cocktail",
      description: "Amaretto, Baileys & Kahlúa.",
      price: "179"
    },
    {
      name: "Aperol Spritz",
      description: "Prosecco, Aperol & Soda.",
      price: "179"
    }
  ],
  ol: [
    {
      name: "Norrlands Guld",
      description: "Sverige, 5.3%",
      price: "109",
      size: "50cl"
    },
    {
      name: "Singha",
      description: "Thailand, 5.0%",
      price: "79",
      size: "33cl"
    },
    {
      name: "Singha",
      description: "Thailand, 5.0%",
      price: "109",
      size: "63cl"
    },
    {
      name: "Kingfisher",
      description: "Indien, 4.5%",
      price: "79",
      size: "33cl"
    },
    {
      name: "Kingfisher",
      description: "Indien, 4.5%",
      price: "109",
      size: "65cl"
    },
    {
      name: "Cobra",
      description: "Indien, 4.5%",
      price: "109",
      size: "66cl"
    },
    {
      name: "Cider Briska Päron",
      description: "Sverige, 4.5%",
      price: "79",
      size: "33cl"
    },
    {
      name: "Carlsberg Pilsner",
      description: "Danmark, 3.5%",
      price: "79",
      size: "33cl"
    },
    {
      name: "Carlsberg",
      description: "Danmark, 0.5% (Alkoholfri)",
      price: "69",
      size: "33cl"
    },
    {
      name: "Somersby Päron",
      description: "Polen, 0.0% (Alkoholfri)",
      price: "69",
      size: "33cl"
    }
  ],
  sprit: [
    {
      name: "Vodka, Gin, Martini, Tequila",
      description: "",
      price: "20",
      unit: "per cl"
    },
    {
      name: "Baileys, Amaretto, Rom, Whiskey, Aperol",
      description: "",
      price: "30",
      unit: "per cl"
    }
  ]
};
